<template>
    <div class="tw-p-8 tw-rounded tw-w-full tw-mt-6" style="background: rgba(12, 74, 110,.9)">
        <div class="tw-flex tw-flex-wrap tw-w-full">
            <div class="tw-w-full tw-my-3  md:tw-my-0 md:tw-w-2/5 tw-flex tw-items-center tw-rounded md:tw-rounded-r-none tw-bg-light">
                <v-multi-select
                        class="tw-relative tw--top-2px tw-p-1"
                        v-model="category"
                        :options="categories"
                        label="label"
                        track-by="title"
                        placeholder="Select A Category"
                        :clearOnSelect="false"
                        :closeOnSelect="true"
                        :preserveSearch="true"
                        :searchable="true"
                        :loading="categoryLoading"
                        @search-change="searchCategory"
                />
            </div>
            <div class="tw-w-full tw-my-3  md:tw-my-0 md:tw-w-2/5 tw-flex tw-items-center tw-rounded md:tw-rounded-none tw-bg-light">
                <v-multi-select
                        class="tw-relative tw--top-2px tw-p-1"
                        v-model="suburb"
                        :options="suburbs"
                        label="label"
                        track-by="title"
                        placeholder="Select A Suburb"
                        :clearOnSelect="false"
                        :closeOnSelect="true"
                        :preserveSearch="true"
                        :searchable="true"
                        :loading="suburbLoading"
                        @search-change="searchSuburb"
                />
            </div>
            <button v-on:click="openSubmitTask" type="button"
                    class="tw-w-full md:tw-w-1/5 tw-mt-2 md:tw-mt-0 tw-p-4 tw-py-6 tw-bg-secondary cursor:tw-bg-secondary-cursor tw-text-light tw-font-bold tw-rounded md:tw-rounded-l-none tw-text-2xl">
                Get Quotes
            </button>
        </div>
    </div>
</template>

<script>

    export default {
        props:['current_category'],
        data() {
            return {
                categories: [],
                suburbs: [],
                category: null,
                suburb: null,
                isModalVisible: false,
                categoryLoading: true,
                suburbLoading: true
            };
        },
        created() {
            if(this.current_category){
                this.category = this.current_category
            }
            this.searchCategory();
            this.searchSuburb();
        },
        methods: {
            openSubmitTask() {
                // validate ..
                document.dispatchEvent(new CustomEvent('open-get-quote-with-defaults', {
                    detail: {
                        suburb: this.suburb,
                        category: this.category
                    }
                }))
            },
            searchCategory(query) {
                let self = this
                self.categoryLoading = true
                axios.get(`/api/v1/search/category`, {
                    params: {query}
                })
                    .then(resp => {
                        self.categoryLoading = false
                        self.categories = resp.data.data
                    })
                    .catch(err => {
                        self.categoryLoading = false
                    })
            },
            searchSuburb(query) {
                let self = this
                self.suburbLoading = true
                axios.get(`/api/v1/search/suburb`, {
                    params: {query}
                }).then(resp => {
                    self.suburbLoading = false
                    self.suburbs = resp.data.data
                })
                    .catch(err => {
                        self.suburbLoading = false
                    })
            }
        }
    };
</script>
<style>
    .multiselect__option--highlight {
        @apply bg-secondary !important;
    }

    .multiselect__option--highlight:after {
        @apply bg-primary !important;
    }

    .multiselect__tags {
        @apply border-none;
    }
</style>
